import React from 'react'
import style from './Solicitar.module.css'

const Solicitar = ({ t }) => {
  const url = t('Products.sscEnterprise.Request.url')

  return (
    <div className={style.servicios}>
      <div className={style.divText}>
        <p className={style.text1}>
          {t('Products.sscEnterprise.Request.text')}{' '}
          <strong style={{ fontWeight: 'bold', color: 'black' }}>
            {t('HomePage.Products.supervision-and-control-system')}
          </strong>.
        </p>

        <p className={style.text2}>
          {t('Products.sscEnterprise.Request.text2')}
        </p>
      </div>

      <div className={style.divButton}>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={style.link}
        >
          <div className={style.contacto}>
            {t('Products.sscEnterprise.Request.text3')}
          </div>
        </a>
      </div>
    </div>
  )
}

export default Solicitar
